/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `training_settings` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class TrainingSettingsMesg : Mesg {
    public constructor() : super("TrainingSettings", Profile.MesgNum.TRAINING_SETTINGS)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** target_distance, in m. */
    public var targetDistance: Double?
        get() = getFieldValue(TARGET_DISTANCE_FIELD_NUM) as? Double
        set(value) = setFieldValue(TARGET_DISTANCE_FIELD_NUM, value)

    /** target_speed, in m/s. */
    public var targetSpeed: Double?
        get() = getFieldValue(TARGET_SPEED_FIELD_NUM) as? Double
        set(value) = setFieldValue(TARGET_SPEED_FIELD_NUM, value)

    /** target_time, in s. */
    public var targetTime: UInt?
        get() = getFieldValue(TARGET_TIME_FIELD_NUM) as? UInt
        set(value) = setFieldValue(TARGET_TIME_FIELD_NUM, value)

    /** precise_target_speed, in m/s. A more precise target speed field */
    public var preciseTargetSpeed: Double?
        get() = getFieldValue(PRECISE_TARGET_SPEED_FIELD_NUM) as? Double
        set(value) = setFieldValue(PRECISE_TARGET_SPEED_FIELD_NUM, value)

    public companion object {
        public const val TARGET_DISTANCE_FIELD_NUM: UByte = 31u
        public const val TARGET_SPEED_FIELD_NUM: UByte = 32u
        public const val TARGET_TIME_FIELD_NUM: UByte = 33u
        public const val PRECISE_TARGET_SPEED_FIELD_NUM: UByte = 153u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[31] = Field("TargetDistance", 31u, BaseType.UINT32, 100.0, 0.0, "m", false)
            fields[32] = Field("TargetSpeed", 32u, BaseType.UINT16, 1000.0, 0.0, "m/s", false)
            fields[33] = Field("TargetTime", 33u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[153] = Field("PreciseTargetSpeed", 153u, BaseType.UINT32, 1000000.0, 0.0, "m/s", false)
            return fields
        }
    }
}
